module.exports = __webpack_public_path__ + "img/tab_img.30509d0.png";